/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useRef, useState } from "react";
import "./MapLegend.scss";
import CaretUpIcon from "calcite-ui-icons-react/CaretUpIcon";
import CaretDownIcon from "calcite-ui-icons-react/CaretDownIcon";
import Legend from "@arcgis/core/widgets/Legend";
import { MapContext } from "../../context/MapContext";
import { Rnd } from "react-rnd";

function MapLegend() {
  const legendDiv = useRef(null);
  const nodeRef = useRef(null);
  const [mapObject] = useContext(MapContext);
  const [legendIsOpen, setLegendIsOpen] = useState(true);
  //const [defaultValue, setDefault] = useState(null);

  //Function setup to make sure legend isn't sitting outside of the page view
  const keepLegendInView = () => {
    //this whole thing is acting funky. I'm just trying to make sure the user has something they can drag and move back into position.
    const maxH = window.outerHeight;
    const maxW = window.outerWidth;
    const node = nodeRef.current;
    const legendLocation =
      node.resizableElement.current.getBoundingClientRect();
    let newX, newY;
    if (legendLocation.x + legendLocation.width > maxW) {
      newX = maxW - (legendLocation.width + 20);
    }
    if (legendLocation.y + legendLocation.height > maxH) {
      newY = maxH - (legendLocation.height + 20);
    }

    if (newX || newY) {
      node.updatePosition({
        x: newX || legendLocation.x,
        y: newY || legendLocation.y,
      });
    }
  };

  const setInitialLegendLocation = () => {
    if (nodeRef !== null) {
      const node = nodeRef.current;
      const x =
        node.resizableElement.current.parentElement.parentElement.getBoundingClientRect()
          .width + 220;
      const y =
        node.resizableElement.current.parentElement.parentElement.getBoundingClientRect()
          .height - 380;

      //get out of
      setTimeout(() => {
        node.updatePosition({ x, y });
      });
    }
  };

  useEffect(() => {
    /**
     * Add event listener
     */
    window.addEventListener("resize", keepLegendInView);

    //set intial location for legend
    setInitialLegendLocation();

    /**
     * Remove event listener
     */
    return function cleanup() {
      window.removeEventListener("resize", keepLegendInView);
    };
  }, []);

  useEffect(() => {
    if (legendDiv.current && mapObject?.view) {
      new Legend({
        container: legendDiv.current,
        view: mapObject.view,
      });
    }
  }, [legendDiv, mapObject?.view]);

  const toggleLegend = () => {
    setLegendIsOpen(!legendIsOpen);
  };

  return (
    <Rnd
      className={legendIsOpen ? "draggable" : "draggable isClosed"}
      default={{
        x: 0,
        y: 0,
        width: 240,
        height: 350,
      }}
      ref={nodeRef}
    >
      <div>
        <div className="mapLegend">
          <div className="legendHeader handle">
            <div className="legendTitle">Map Legend</div>
            <div onClick={toggleLegend} className="legendToggle">
              {legendIsOpen ? <CaretUpIcon /> : <CaretDownIcon />}
            </div>
          </div>
          <div
            className={legendIsOpen ? "esriLegend" : "esriLegend legendClosed"}
            ref={legendDiv}
          />
        </div>
      </div>
    </Rnd>
  );
}

export default MapLegend;